<template>
    <div :class="getCSSClass('model-manager-header-buttons-container')">
        <button type="button"
                :class="getCSSClass('model-manager-new-button')"
                @click="emitCopy"
                v-html="icon('calendar')+translate('Új koncert meglévő másolatával')"></button>
        <button type="button"
                :class="getCSSClass('model-manager-new-button')"
                @click="emitNew"
                v-html="icon('calendar')+translate('Új koncert')"></button>
    </div>
</template>

<script>
    export default {
        inject: ['getCSSClass', 'loadingIndicator', 'icon', 'locale', 'translate'],
        props: {
            buttons: {type: Object},
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {
            emitNew: function() {
                this.$emit('new');
            },
            emitCopy: function() {
                this.$emit('component', {subComponents: {'editFormComponent': 'CopyConcertComponent'}});
                window.setTimeout(() => {
                    this.emitNew();
                }, 200);
            }
        },
        computed: {},
        watch: {}

    }
</script>
